// Estado compartilhado entre o botao unico dos assistentes e o que ele abre.
// Um botao so no canto: o Assistente de Suporte, o Jarvis e o Capitao saem dele.
import { ref } from 'vue';

// Onde o botao esta (right/bottom em px): o Jarvis abre logo acima dele.
export const hubAnchor = ref(null);

// Painel lateral do Assistente de Suporte.
export const isSupportPanelOpen = ref(false);

// O Jarvis e grande e vive no proprio componente; o botao so pede para abrir.
export const JARVIS_TOGGLE_EVENT = 'assistantHub:toggleJarvis';

// Altura do botao + folga, para o que abre acima dele nao cobri-lo.
export const HUB_STACK_OFFSET_PX = 64;
